import React from 'react';

import Loader from "./loader";
import "./button.css";

interface ButtonProps {
    children: React.ReactNode;
    variant?: string;
    className?: string;
    type?: "button" | "reset" | "submit" | undefined;
    isLoading?:boolean;
}


export default function Button({type="submit", children, variant="primary", className = "w-100", isLoading = false}: ButtonProps) {
    return <button type={type} disabled={isLoading} className={`btn btn-${variant} py-3 d-flex justify-content-center align-items-center gap-3 ${className}`}>
        {
            isLoading ? (
                <Loader />
            ) : (
                <></>
            )
        }
        {children}
    </ button>

}